// Helpers for <input type="datetime-local">, which reads and writes *local*
// wall-clock strings (`YYYY-MM-DDTHH:mm`) with no timezone.
//
// The tempting `new Date(value).toISOString().slice(0, 16)` is wrong here:
// toISOString() returns UTC, so it fills the local input with the UTC
// wall-clock time (e.g. an 8:30pm Central visit shows as 01:30 the next day).
// Build the string from the Date's *local* components instead. See #64.

export function toLocalDatetimeInputValue(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}
